import { PaginationResponse } from "@/main/models/common/paginationResponse";
import { ProcurementReportScheduleGridResponse } from "@/main/models/response";
import { AxiosResponse } from "axios";

export abstract class IProcurementReportScheduleStatusAPI {
	abstract getProcurementReportScheduleStatus(): Promise<
		AxiosResponse<PaginationResponse<ProcurementReportScheduleGridResponse[]>>
	>;
}
